import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchLocationLink } from 'redux/location-links/actions';

import CommonLinkCheckbox from 'components/common/link-elements/CommonLinkCheckbox';

import './LocationLinkIsPublished.css';


function LocationLinkIsPublished(props) {
  const { linkItem, patchLocationLink } = props;

  return (
    <div className="location-link-is-published__component">
      <CommonLinkCheckbox
        key={`location-link-is-published-checkbox-key-${linkItem.id}`}
        linkId={linkItem.id}
        initialValue={linkItem.is_published}
        parameter="is_published"
        patchFunction={patchLocationLink}
      />
    </div>
  );
}

LocationLinkIsPublished.propTypes = {
  patchLocationLink: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
};

export default connect(
  null,
  {
    patchLocationLink,
  },
)(LocationLinkIsPublished);
